import {useSignals} from '@preact/signals-react/runtime'
import moment from 'moment'
import 'moment/locale/bg'
import 'moment/locale/en-gb'
import {useEffect, useState} from 'react'
import {useAppConfig} from '../context/app/AppContext'
import {getLanguageCode} from '../i18n/LanguageUtils'

const DatePicker = () => {
    useSignals()
    const {timezoneId} = useAppConfig()
    // eslint-disable-next-line no-unused-vars
    const [tick, setTick] = useState(false)

    useEffect(() => {
        const countDown = setInterval(() => {
            setTick(prevState => !prevState)
        }, 1000)

        return () => clearInterval(countDown)
    }, [])

    return (
        <div className="flex col-12 flex-column md:flex-row gap-3 md:align-items-center bg-primary border-round-xl p-3">
            <div className="flex col-12 flex-column align-items-center">
                <span className="block mb-1 text-3xl font-semibold">
                    {moment()
                        .tz(timezoneId)
                        ?.locale(
                            getLanguageCode() === 'gb'
                                ? 'en'
                                : getLanguageCode(),
                        )
                        .format('LTS')}
                </span>
                <span className="mt-0 text-xl">
                    {moment()
                        .tz(timezoneId)
                        ?.locale(
                            getLanguageCode() === 'gb'
                                ? 'en'
                                : getLanguageCode(),
                        )
                        .format('dddd DD MMM YYYY')}
                </span>
            </div>
        </div>
    )
}

export default DatePicker
